import React from 'react';
import './ChatHistoryModal.css';

const ChatHistoryModal = ({ savedChats, onLoadChat, onClose, onDeleteChat }) => {
  return (
    <div className="chat-history-modal">
      <h2>Previous Chats</h2>
      <div className="saved-chats-list">
        {Object.entries(savedChats).length === 0 ? (
          <p className="no-chats">No saved chats found</p>
        ) : (
          Object.entries(savedChats).map(([title, chat]) => (
            <div key={title} className="chat-item">
              <div 
                className="chat-content"
                onClick={() => onLoadChat(chat)}
              >
                <h3>{title}</h3>
                <p className="timestamp">{new Date(chat.timestamp).toLocaleString()}</p>
              </div>
              <button 
                className="delete-chat-button"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteChat(title);
                }}
                title="Delete chat"
              >
                ×
              </button>
            </div>
          ))
        )}
      </div>
      <button className="close-button" onClick={onClose}>Close</button>
    </div>
  );
};

export default ChatHistoryModal; 